<script lang="ts" setup>

  const props = defineProps({
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
    }
  })
</script>


<template>
  <div class="readonly-component">
    <template v-if="props.readOnly">
      <span class="form-title">{{props.title}}</span>
      <span class="form-value">{{props.value}}</span>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<style scoped>
.readonly-component {
  vertical-align: top;
}
.form-title {
  display: block;
  margin-right: 0.5vw;
  font-size: x-small;
}
.form-value {
  margin-left: 1vw;
  font-size: medium;
}
</style>
